<template>
  <v-row>
    <v-col cols="12">
      <v-row>
        <v-col cols="12" sm="12" md="3" lg="2">
          <v-btn @click="excel" color="success">
            <v-icon>
              mdi-file-excel
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12">
      <v-data-table
        :headers="headers"
        :items="items"
        :search="filter"
        hide-default-footer
        disable-pagination
      >
        <template v-slot:top>
          <v-row>
            <v-col cols="12" sm="12" md="8" lg="8">
              <v-text-field
                flat
                dense
                outlined
                background-color="white"
                v-model="filter"
                placeholder="search"
                append-icon="mdi-magnify"
                single-line
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
        </template>
        <template v-slot:item.no="{ index }">
          {{ index + 1 }}
        </template>
        <template v-slot:item.amount="{ item }">
          {{ formatPrice(item.amount) }}
        </template>
      </v-data-table>
    </v-col>
  </v-row>
</template>

<script>
import fileDownload from "js-file-download";

export default {
  name: "report-down-paymnet",
  data() {
    return {
      type: "sale",
      listType: ["sale", "purchase"],
      items: [],
      filter: "",
      headers: [
        {
          text: "No",
          align: "center",
          value: "no",
          divider: true,
          sortable: false,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          text: "Account Number",
          align: "center",
          value: "accountNumber",
          divider: true,
          sortable: false,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          text: "Account Name",
          align: "left",
          value: "accountName",
          divider: true,
          sortable: false,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          text: "Type",
          align: "center",
          value: "type",
          divider: true,
          sortable: false,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          text: "Amount",
          align: "center",
          value: "amount",
          divider: true,
          sortable: false,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          text: "Currency",
          align: "center",
          value: "currency",
          divider: true,
          sortable: false,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          text: "Date",
          align: "center",
          value: "date",
          divider: true,
          sortable: false,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          text: "RR#",
          align: "left",
          value: "rrNumber",
          divider: true,
          sortable: false,
          class: "light-blue lighten-2 font-weight-black",
        },
      ],
    };
  },
  methods: {
    async search() {
      this.$store.commit("SET_LOADER", true);
      await this.$store
        .dispatch("report/otherDebts")
        .then(response => {
          this.items = response.data;
          this.$store.commit("SET_LOADER", false);
        })
        .catch(() => {
          this.$store.dispatch("toast", {
            type: "error",
            message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
          });
          this.$store.commit("SET_LOADER", false);
        });
    },
    async excel() {
      this.$store.commit("SET_LOADER", true);
      await this.$store
        .dispatch("report/otherDebtExcel")
        .then(response => {
          fileDownload(response.data, `report-other-debt.xlsx`);
          this.$store.commit("SET_LOADER", false);
        })
        .catch(() => {
          this.$store.dispatch("toast", {
            type: "error",
            message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
          });
          this.$store.commit("SET_LOADER", false);
        });
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
  },
  mounted() {
    this.search();
  },
};
</script>

<style scoped>
table,
th,
td {
  border: 1px solid grey;
}
</style>
